import { render, staticRenderFns } from "./PlainGold.vue?vue&type=template&id=4408aedc&scoped=true&"
import script from "./PlainGold.vue?vue&type=script&lang=js&"
export * from "./PlainGold.vue?vue&type=script&lang=js&"
import style0 from "./PlainGold.vue?vue&type=style&index=0&id=4408aedc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408aedc",
  null
  
)

export default component.exports